import React, { useState } from 'react';
import './MembersGrid.scss';
import { useLocation } from 'react-router-dom';

import service from '../../data/members.js';
import GlobalParams from '../../helpers/GlobalParams.js';
import parameters from '../../data/data.js';
import notify from 'devextreme/ui/notify';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import Form, { Item, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions } from 'devextreme-react/form';
import { Button, Lookup, TextBox, LoadPanel, Popup, Menu, NumberBox } from 'devextreme-react';
import NewClaim from '../NewClaim/NewClaim.js';


const isDateInRange = (date_from, date_to, check_date) => {
  return check_date >= date_from && check_date <= date_to;
}

function MembersGrid({ membersData,vsClaims }) {

  //const [vsClaims, setVsClaims] = useState(false);
  //const [membersData, setData] = useState(memberStore);
  const [member_name, setMemberName] = React.useState('');
  const [member_no, setMemberNo] = React.useState('');
  const [member_id, setMemberId] = React.useState('');
  const [schemeID, setSchemeID] = React.useState(null);
  const [vsMedicalsReceived, setVsMedicalsReceived] = React.useState(false);
  const [vsMedicalsAwaiting, setVsMedicalsAwaiting] = React.useState(false);
  const [vsMedicalsValid, setVsMedicalsValid] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //var membersData = service.getMembersStore();
  var searchPanelOptions = {
    visible: false,
    width: 250
  };
  var schemeIDOptions = {
    dataSource: GlobalParams.schemeStore, valueExpr: 'schemeID', displayExpr: 'SchemeDescription'
  }
  var groupOptions = {
    contextMenuEnabled: true, groupPanel: { visible: true },
  }
  var scrollingOptions = { mode: 'standard' }
  var pagingOptions = { enabled: false }


  const onMenuItemClaimsClick = (cellInfo, item) => {
    if (item === 'Request New Claim') {
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      console.log('Request New Claim');
      // Handle the Request New Claim action
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      console.log('Request New Claim');
      showClaimPopup();
    }
  };


  const menuClaimsItems = [
    { text: 'Request New Claim', icon: 'edit' },
  ];//

  const actionClaimsTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuItemClaimsClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuClaimsItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };

  ///////claim popup functions//
  const [popupClaimVisible, setPopupClaimVisible] = useState(false);
  const showClaimPopup = () => {
    setPopupClaimVisible(true);
  };
  const hideClaimPopup = () => {
    //notify("Claim Request Successfully Submite", 'success', 4000);
    setPopupClaimVisible(false);
  };
  /////////end of claim popup functions//

  


  return (
    <div>
      <div>
        {popupClaimVisible && (
          <Popup
            visible={popupClaimVisible}
            title="REQUEST A NEW CLAIM"
            dragEnabled={true}
            showCloseButton={true}
            hideOnOutsideClick={true}
            onHiding={hideClaimPopup}
          >
            <NewClaim
              onClosePopup={hideClaimPopup}
              MemberName={member_name}
              MemberNumber={member_no}
              MemberId={member_id}
              PolicyNo={schemeID}
              IsApproval={0}
            />
          </Popup>
        )}
      </div>
      <div>
        <DataGrid keyExpr="member_no"
          dataSource={membersData} wordWrapEnabled={true} columnHidingEnabled={true}
          searchPanel={searchPanelOptions} grouping={groupOptions}
          allowColumnReordering={true} scrolling={scrollingOptions} paging={pagingOptions}
        >
          <Column dataField="SchemeID" visible={false} />
          <Column dataField="MemberId" visible={false} />
          <Column dataField="Salary" visible={false} />
          {/* Action column vsMovement  */}
          <Column width={50} caption="" visible={vsClaims} cellRender={actionClaimsTemplate} />
          <Column dataField="Names"></Column>
          <Column dataField="member_no"></Column>
          <Column
            dataField="DateFrom"
            dataType="date" format="dd/MM/yyyy" width={120} visible={false}>
          </Column>
          <Column
            dataField="DateTo"
            dataType="date" format="dd/MM/yyyy" width={120} visible={false}>
          </Column>
          <Column dataField="HasDependants"
            dataType="boolean" visible={false} />
          <Column dataField="LoanNumber" visible={false}></Column>
          <Column dataField="LoanBalance" visible={false} />
          <Column dataField="GrossTotalSumAssured" visible={false} />
          <Column dataField="GrossTotalPremium" visible={false} />

          <Column dataField="med_uw_date" dataType='date' format="dd/MM/yyyy" visible={vsMedicalsReceived} width={120} />
          <Column dataField="med_uw_decision" visible={vsMedicalsReceived}
            lookup={
              { dataSource: GlobalParams.MedicalUwDecision, valueExpr: 'ID', displayExpr: 'uw_name' }}
          />
          <Column dataField="medical_results" visible={false} />
          <Column dataField="MedicalRequestDate" dataType='date' format="dd/MM/yyyy" visible={vsMedicalsAwaiting} width={120} />

          <Column dataField="IsMedicalValid" caption='Medicals Validity' visible={vsMedicalsReceived} />
          <Column dataField="MedicalTestDate" dataType='date' format="dd/MM/yyyy" visible={vsMedicalsReceived} />
        </DataGrid>
      </div>
    </div>
  );
}

export default MembersGrid;